import { render, staticRenderFns } from "./FormPrincipalDependente.vue?vue&type=template&id=09aa0220"
import script from "./FormPrincipalDependente.vue?vue&type=script&lang=js"
export * from "./FormPrincipalDependente.vue?vue&type=script&lang=js"
import style0 from "./FormPrincipalDependente.vue?vue&type=style&index=0&id=09aa0220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports